import { createFileRoute } from '@tanstack/react-router';

import { PostsPage } from '@/features/(insight)/posts/index';

export const Route = createFileRoute('/workspace/$workspaceId/insight/posts')({
  component: PostsPage,
});
